import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { useDateTimeFormatter } from 'platform/locale';
import { parseDate } from 'shared/web';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type DateCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function DateCellRenderer(props) {
  const $ = _c(39);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props) {
    t1 = getStylesToRender(props);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cellStyles = t1 as CellStyle | undefined;
  const formatDateTime = useDateTimeFormatter();
  let t2;
  if ($[4] !== props.getTooltipProps || $[5] !== props.row) {
    t2 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[4] = props.getTooltipProps;
    $[5] = props.row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tooltipProps = t2;
  if (!props.value) {
    return null;
  }
  let T0;
  let T1;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== cellStyles?.textColor || $[8] !== className || $[9] !== formatDateTime || $[10] !== props.column?.wrapText || $[11] !== props.value || $[12] !== tooltipProps) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const parsed = parseDate(props.value);
      if (isNaN(parsed.getTime())) {
        t11 = null;
        break bb0;
      }
      T1 = Tooltip;
      t9 = tooltipProps;
      t10 = formatDateTime("dateTimeLong", parsed);
      t8 = className;
      T0 = Text;
      t3 = cellStyles?.textColor;
      t4 = !props.column?.wrapText;
      t5 = "small";
      t6 = props.column?.wrapText ? "anywhere" : undefined;
      t7 = formatDateTime("dateShort", parsed);
    }
    $[7] = cellStyles?.textColor;
    $[8] = className;
    $[9] = formatDateTime;
    $[10] = props.column?.wrapText;
    $[11] = props.value;
    $[12] = tooltipProps;
    $[13] = T0;
    $[14] = T1;
    $[15] = t10;
    $[16] = t11;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[13];
    T1 = $[14];
    t10 = $[15];
    t11 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[24] !== T0 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t12 = <T0 color={t3} noWrap={t4} size={t5} overflowWrap={t6}>{t7}</T0>;
    $[24] = T0;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[31] = t12;
    $[32] = t8;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== T1 || $[35] !== t10 || $[36] !== t13 || $[37] !== t9) {
    t14 = <T1 {...t9} label={t10}>{t13}</T1>;
    $[34] = T1;
    $[35] = t10;
    $[36] = t13;
    $[37] = t9;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}